export const extractFormConfiguration = (jsonData) => {
  const data = typeof jsonData === 'string' ? JSON.parse(jsonData) : jsonData;
  const transport = data.solutions[0]?.transport;

  if (!transport || !transport.parameters_booking) {
    return {
      passenger: null,
      contact: null,
      ageRanges: {},
      adultInfantTogether: false,
    };
  }

  const formConfig = {
    passenger: {
      fields: {},
      requiredFields: {},
    },
    contact: {
      fields: [],
      requiredFields: [],
    },
    ageRanges: {},
    adultInfantTogether: false,
  };

  const passengerConfig = transport.parameters_booking.find(
    (param) => param.context === 'pax' && param.type === 'passenger'
  );

  if (passengerConfig) {
    if (passengerConfig.info?.range) {
      formConfig.ageRanges = passengerConfig.info.range;
    }

    formConfig.adultInfantTogether =
      passengerConfig.info?.names_validation?.adult_infant_together || false;

    const passengerTypes = ['ADT', 'CHD', 'INF', 'LBR', 'ITX', 'YTH', 'YCD', 'UMN'];

    passengerTypes.forEach((type) => {
      formConfig.passenger.fields[type] = [];
      formConfig.passenger.requiredFields[type] = [];
    });

    passengerConfig.fields.forEach((field) => {
      const fieldPaxRefs = field.pax_refs || [];

      fieldPaxRefs.forEach((paxType) => {
        if (formConfig.passenger.fields[paxType]) {
          formConfig.passenger.fields[paxType].push({
            name: field.name,
            mandatory: field.mandatory,
            editable: field.editable,
            enums: field.enums || null,
            apply_per_passenger: field.apply_per_passenger || false,
          });

          if (field.mandatory) {
            formConfig.passenger.requiredFields[paxType].push(field.name);
          }
        }
      });
    });
  }

  const contactConfig = transport.parameters_booking.find(
    (param) => param.context === 'travel' && param.type === 'contact'
  );

  if (contactConfig) {
    formConfig.contact.mandatory = contactConfig.mandatory || false;

    contactConfig.fields.forEach((field) => {
      formConfig.contact.fields.push({
        name: field.name,
        mandatory: field.mandatory,
        editable: field.editable,
      });

      if (field.mandatory) {
        formConfig.contact.requiredFields.push(field.name);
      }
    });
  }

  return formConfig;
};
